module.exports = __webpack_public_path__ + "img/SL-M-120-190.99389efc.svg";